const t = "Completed step", o = "Back to {buttonName}", e = "Go to {buttonName}", n = {
  completedStep: t,
  backButton: o,
  nextButton: e
};
export {
  o as backButton,
  t as completedStep,
  n as default,
  e as nextButton
};
